import { render, staticRenderFns } from "./_aside.vue?vue&type=template&id=6d79cdb0"
import script from "./_aside.vue?vue&type=script&lang=js"
export * from "./_aside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports